// ItemFeedback — user-flag + rating + optional note for AI-generated content.
//
// Per陛下 19AQ: "给用户一个 flag 的功能，在每一个 ai 生成的内容处都加上，
// 就是可以 flag 是否有误，以及可以让用户打分，但这个不需要醒目，一个小按钮
// 即可。我们未来可以做一个专门的幻觉/错误 check 的组件，但这是后期了。"
//
// Stored alongside ItemOverride in progress.itemFeedback (same key shape:
// `${itemId}.${field}`). Distinct from ItemOverride: feedback is a SIGNAL
// to the operator (was this item useful / wrong?) — it does NOT change what
// the user sees. Future operator-only dashboard will aggregate these into
// per-prompt quality metrics.
//
// Three signal types:
//   - flag: user thinks something is wrong (factual error / unclear / etc)
//   - rating: 1-5 quality rating (optional)
//   - note: optional free-text comment
import { z } from 'zod';
export const ItemFeedbackSchema = z.object({
    /** True if user has clicked the flag — content has a problem. */
    flagged: z.boolean(),
    /** Optional 1-5 quality rating (1 = bad, 5 = great). undefined = not rated. */
    rating: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4), z.literal(5)]).optional(),
    /** Optional free-form note explaining the issue / praise. */
    note: z.string().max(500).optional(),
    /** ISO datetime of last update. */
    updatedAt: z.string().datetime(),
}).passthrough();
/** Same key shape as ItemOverride for IDB access symmetry. */
export function feedbackKey(itemId, field) {
    return `${itemId}.${field}`;
}
//# sourceMappingURL=item-feedback.js.map